import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { CommonModule, formatDate } from '@angular/common';
import { AbstractControl, ControlValueAccessor, FormBuilder, FormControl, FormsModule, NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule, ValidationErrors, Validator, Validators } from '@angular/forms';
import { QuestionType } from 'src/app/models/questionType.model';
import { OptionsList } from 'src/app/models/optionsList.model';
import { Question } from 'src/app/models/question.model';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MenuQuestionComponent } from '../menu-question/menu-question.component';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { ToggleComponent } from "src/app/shared/components/toggle/toggle.component";

@Component({
    selector: 'que-date-question',
    imports: [CommonModule, ReactiveFormsModule, FormsModule, MatCheckboxModule, MenuQuestionComponent, TranslateDirective, TranslatePipe, SvgIconComponent, ToggleComponent],
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: DateQuestionComponent,
            multi: true
        },
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: DateQuestionComponent,
            multi: true
        }
    ],
    templateUrl: './date-question.component.html',
    styleUrls: ['./date-question.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DateQuestionComponent implements OnInit, ControlValueAccessor, Validator {
  @Input() index?: number;

  @Output() focusEvent = new EventEmitter<boolean>();

  #builder = inject(FormBuilder);
  questionForm = this.#builder.group({
    formatDate: new FormControl<string>('')
  });

  registerOnChangeCallback: any = () => { };
  onValidationChangeCallBack: any;
  orginalQuestion?: Question;

  ngOnInit(): void {
    this.questionForm.valueChanges.subscribe(question => {
      this.registerOnChangeCallback({
        ...this.orginalQuestion,
        definitions: {
          ...this.orginalQuestion?.definitions,
          formatDate: question.formatDate
        }
      });
    });
  }

  validate(control: AbstractControl<any, any>): ValidationErrors | null {
    if (this.questionForm.valid) {
      return null;
    }
    return { 'optionsValue': "not-valid" }
  }

  writeValue(obj: Question): void {
    this.orginalQuestion = obj;
    this.questionForm.patchValue({
      formatDate: obj.definitions?.formatDate
    },
      { emitEvent: false });
  }
  registerOnValidatorChange?(fn: () => void): void {
    this.onValidationChangeCallBack = fn;
  }

  registerOnChange(fn: any): void {
    this.registerOnChangeCallback = fn;
  }
  registerOnTouched(fn: any): void {
  }

  markFormatDate(value: boolean) {
    if (value)
      this.questionForm.controls.formatDate.setValue('YYYY/MM')
    else
      this.questionForm.controls.formatDate.setValue('')
  }
}
